import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import React from "react";
import { Fab, Grid, List, CircularProgress } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { observer } from "mobx-react-lite";
import ItemList from "../../../../../components/Modal/ItemList";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";

const Modelos = observer(({ classes, TGOStore, onChangeTipoListagem }) => {
  const handleClickCriarNovoModelo = () => {
    TGOStore.resetModelo();
    TGOStore.changeFieldsStore({
      indicacaoClinicaTemporaria: TGOStore.objView.indicacaoClinica,
      guiaServicoTussViewsTemporaria: TGOStore.objView.guiaServicoTgoTussViews,
      observacaoTemporaria: TGOStore.objView.observacao,
      isProntuario: true,
      typeModal: "novoModal"
    });

    onChangeTipoListagem("sugestoes");
  };

  const handleClickSelecionarModelo = (item) => {
    const { objView } = TGOStore;
    TGOStore.resetModelo();
    objView.observacao = `${objView.observacao} ${item.observacao}`;
    objView.guiaServicoTgoTussViews = [
      ...objView.guiaServicoTgoTussViews,
      ...item.guiaServicoModeloTgoTussViews,
    ];
    objView.indicacaoClinica = {
      label: item.cid10Subcategoria.descricaoAbreviada,
      value: item.cid10Subcategoria.id,
    };

    TGOStore.registroQuantidadeUso(item.id);
  };

  const loadMoreModelos = async () => {
    if (TGOStore.modelosLoadingModal) {
      return;
    }

    TGOStore.modelosPagAtual =
      TGOStore.modelos.length > 0 ? TGOStore.modelosPagAtual + 1 : 0;
    await TGOStore.findAllGuiaServicoModelo({
      searchDTO: {
        ativo: true,
      },
      pageableDTO: {
        pageSize: 10,
        pageNumber: TGOStore.modelosPagAtual,
        sortDir: "DESC",
        sortField: "quantidadeUso",
      },
    });
  };

  return (
    <Grid className={classes.opcaoModelo}>
      <Fab
        id="prt-gtg-btn-cnm"
        className={classes.criarNovoModelo}
        onClick={handleClickCriarNovoModelo}
      >
        <AddIcon />
        <span className={classes.labelCriar}>Criar novo modelo </span>
      </Fab>
      <Scroll
        loadMore={loadMoreModelos}
        hasMore={!TGOStore.modelosLast}
        pageStart={0}
        className={classes.scrollContainerModelos}
      >
        <List>
          {TGOStore.modelos.map((item, index) => (
            <Grid
              id={`prt-gtg-div-mod-${index}`}
              key={index}
              className={classes.cardModelo}
              onClick={() => handleClickSelecionarModelo(item)}
            >
              <ItemList
                size={12}
                field={"Modelo:"}
                className={classes.itemList}
                value={item.nome}
              />
            </Grid>
          ))}
          {TGOStore.modelosLoadingModal && (
            <div className={classes.notFoundContainer}>
              <CircularProgress style={{ color: "#fff" }} />
            </div>
          )}
        </List>
      </Scroll>
    </Grid>
  );
});

const styles = {
  opcaoModelo: {
    alignSelf: "center",
    height: "65%",
  },
  criarNovoModelo: {
    backgroundColor: "#F9BE73",
    height: 40,
    width: 272,
    borderRadius: 100,
    textTransform: "capitalize",
    color: "#fff",
    alignSelf: "center",
    margin: "0 0 11px 8px",
  },
  labelCriar: {
    paddingLeft: 10,
  },
  scrollContainerModelos: {
    overflowY: "auto",
    height: "60vh",
    maxHeight: "100%",
    "@media (max-height: 620px)": {
      height: "50vh",
    },
  },
  cardModelo: {
    margin: "16px 0",
    background: "#fff",
    alignSelf: "center",
    padding: 10,
    borderRadius: 10,
    width: 272,
    cursor: "pointer",
  },
  itemList: {
    fontSize: "12px !important",
    fontFamily: "Poppins !important",
  },
  notFoundContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80%",
    margin: 20,
  },
};

const ModelosWithStyles = withStyles(styles)(Modelos);
export default inject("TGOStore")(ModelosWithStyles);
